<div class="">
  <p class="tw-font-bold tw-text-lg">Subscription Benefits</p>
  <br>

  <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
    <div class="tw-flex tw-rounded-md tw-p-4 tw-gap-2 tw-items-center tw-bg-[#F7F7F7]" *ngFor="let item of noHassles; index as i;">
      <img src="{{item.icon}}" alt="" srcset="" class="tw-w-12 tw-object-scale-down tw-align-middle">
      <div class="tw-block tw-pl-2">
        <p class="tw-text-base tw-font-bold">{{item.title}}</p>
        <p class="tw-text-xs">{{item.description}}</p>
      </div>
    </div>
  </div>
</div>